export default {
  ADD_PRODUCT: 'product/ADD_PRODUCT',
  CHANGE_COLOR: 'product/CHANGE_COLOR',
  DELETE_PRODUCT: 'product/DELETE_PRODUCT',
  REPLACE_PRODUCTS: 'product/REPLACE_PRODUCTS',
  REPLACE_PRODUCTS_CART_MODE: 'product/REPLACE_PRODUCTS_CART_MODE',
  RESET: 'product/RESET',
  SELECT_PRODUCT: 'product/SELECT_PRODUCT',
  SWAP_PRODUCT: 'product/SWAP_PRODUCT',
  UPDATE_CATEGORY_PATHS: 'product/UPDATE_CATEGORY_PATHS',
  UPDATE_SIZE_OPTIONS: 'product/UPDATE_SIZE_OPTIONS',
  UPDATE_HAS_INVALID_PRODUCT_IMAGES:
    'product/UPDATE_HAS_INVALID_PRODUCT_IMAGES',
  SET_ANCHOR_STYLE_AND_COLOR_ID: 'product/SET_ANCHOR_STYLE_AND_COLOR_ID'
};
